import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
// import CorporatePresentations from "../../../PDF/Corporate Presentation.pdf";
import CorporatePresentations from "../../../PDF/Corporate Presentation July 2025.pdf";
import CorporateBanner from "../../../images/Corporate_banner.png"
import "../../FinQ/FinQSection/DocumentGallery/Document.css"


const CorporatePresentation = () => {
  return (
    <section>
    <Container>
       
        <Row>
            <Col sm={12} md={12}>
           <div className="section-header">
             <div className="iap-download">
                                <a target="_balnk" href={CorporatePresentations}  style={{ fontSize: "20px", fontWeight: "bold" }}>
                                  Download Corporate Presentation (PDF)
                                </a>
             </div>
            </div>

 {/* <div className='container'>
              <div className="documents-grid-container">
            <div
            className="documents-card"
            style={{ width: "100%", overflow: "hidden" }}
            >
            <img
                style={{ width: "100%", height: "auto" }}
                src={CorporateBanner} // Change this to your actual image path
                alt="Corporate Presentation"
                onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/path/to/fallback-image.jpg"; // Optional fallback
                }}
            />

            <div className="card-content">
                <h3>Corporate Presentation</h3>
                <a
                href={CorporatePresentations} // Your static PDF link variable
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                Read More
                </a>
            </div>
</div>
                
              </div>

 </div> */}

            </Col>

        </Row>
    </Container>

    </section>
  )
}

export default CorporatePresentation